import React, { useEffect, useCallback } from "react";

import {Box, styled, List, ListItem, IconButton, Button } from "@mui/material";
import { Grid, Typography, Divider, CircularProgress, Tooltip } from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import { budgetActions } from "../actions/budget.action";

import EditIcon from "@mui/icons-material/Edit";
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import { Link, useNavigate } from "react-router-dom";
import { currencyFormat, getOrdinal, escapeHtml } from "../helpers/common";
// Components
import EditBudgetDialog from "../Pages/EditBudgetDialog/EditBudgetDialog";

import axiosInstance from './../interceptor/interceptor';

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default function Budget() {
  // const [dense, setDense] = React.useState(false);
  // const [secondary, setSecondary] = React.useState(false);
  const [budgetId, setBudgetId] = React.useState("");
  const [openEditDialog, setOpenEditDialog] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const budgetList = useSelector((state) => state.budgetReducer.budgets);
  const currency = localStorage.getItem('currency');
  const error = useSelector((state) => state.budgetReducer.error);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    fetchBudget();
  }, []);

  function fetchBudget() {
    try {
      const user_id = localStorage.getItem("user_text_obj_data1");
      dispatch(budgetActions.getBudgetList2({ user_id: user_id, status: 1 }));
      if(error){
        toast.info(`${error}`, { type: "error" });
      }
    } catch (e) {
      alert(e);
    }
  }
  // Edit dialog methods
  const closeDialogHandler = useCallback(function _handleClose() {
    setOpenEditDialog(false);
    dispatch(
      budgetActions.getBudgetList2({ user_id: localStorage.getItem("user_text_obj_data1"), status: 1 })
    );
  }, []);

  function budgetEditHandler(budget_id) {
    setBudgetId(budget_id);
    setOpenEditDialog(true);
  }

  const budgetArchiveHandler = async (budget_id) => {
    try {
      let result = window.confirm("Want to archive?");
      if (result) {
        setIsLoading(true);
        const res = await axiosInstance.post(
          `api?method=update_budget_status`,
          { budget_id: budget_id, status: 2 }
        );
        setIsLoading(false);
        toast(res.data.message);
        setTimeout(()=>{
          dispatch(
            budgetActions.getBudgetList2({
              user_id: localStorage.getItem("user_text_obj_data1"),
              status: 1
            })
          );  
        }, 0);

      }
    } catch (e) {
      toast.info(`Error: ${e}`, { type: "error" });
    }
  };

  function moveBack(){
    navigate("/web");
  }

  // End Edit dialog methods

  // function numberWithCommas(x) {
  //   return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // }

  function renderSwitch(occurance, date_of_month, months) {
    if (occurance == 1) {
      return <Typography className="upperText">One Time Payment</Typography>;
    } else if (occurance == 2 && date_of_month !== null) {
      return (
        <Typography className="upperText">
          On {getOrdinal(date_of_month)} of Every Month
        </Typography>
      );
    } else if(date_of_month !== null){
      return (
        <Typography className="upperText">
          On {getOrdinal(date_of_month)} of {months}
        </Typography>
      );
    }
  }

  return (
    <Box className="tabpanel-data">
      <EditBudgetDialog
        open={openEditDialog}
        closeHandler={closeDialogHandler}
        budgetId={budgetId}
      />
      <Box sx={{ width: "100%" }}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <h3 style={{ textAlign: "center" }}>
            <Button onClick={moveBack} className="top-nav-btn" variant="outlined">
                <KeyboardBackspaceRoundedIcon style={{ cursor: "pointer", float: 'left',marginLeft: '10px !important' }} />
              </Button>
              Budget List (<Link className="archive-box" to="/archive">Archive List</Link>)</h3>
              
              

            <Demo style={{ minHeight: "500px" }}>
              {budgetList ? (
                <List>
                  {budgetList.map((data, index) => (
                    <div key={index}>
                      <ListItem
                        secondaryAction={
                          <>
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={() => budgetEditHandler(data.budget_id)}
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              edge="end"
                              aria-label="remove"
                              onClick={() =>
                                budgetArchiveHandler(data.budget_id)
                              }
                            >
                              <Tooltip title="Click to Archive">
                              <ArchiveOutlinedIcon />
                              </Tooltip>
                              
                            </IconButton>
                          </>
                        }
                      >
                        <div className="img-round">
                          <Box
                            component="img"
                            direction="column"
                            className="grid-item"
                            sx={{
                              maxHeight: { xs: 233, md: 167 },
                              maxWidth: { xs: 350, md: 250 },
                            }}
                            alt="Budget icon"
                            src={"./images/icons/" + data.budget_icon}
                          />
                        </div>
                        <div className="content_budget">
                          <h4>
                            {escapeHtml(data.name)}
                            <span className="budget-amount">
                              {currencyFormat(data.amount, currency)}
                            </span>
                          </h4>
                          {renderSwitch(
                            data.occurance,
                            data.date_of_month,
                            data.months
                          )}

                          <Typography className="botTexts">
                            {data.note}
                          </Typography>
                        </div>
                      </ListItem>
                      <Divider
                        sx={{
                          marginLeft: "5%",
                          marginRight: "5%",
                        }}
                      />
                    </div>
                  ))}
                </List>
              ) : (
                <>
                  <div id="overlay">
                    <div className="loader">
                      <CircularProgress />
                    </div>
                  </div>
                </>
              )}
            </Demo>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

